import React, {useEffect, useContext, useState} from 'react';
import { PageSettings } from './../../config/page-settings.js';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import ReactNotification, { store } from 'react-notifications-component';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import moment from 'moment';

import Services from '../../services/service';
import { BASE_URL } from '../../config/constants.js';

const FormPreview = props => {

  let contextType = useContext(PageSettings);
  const jobID = props.location.state.job_id;

  const [dataFile, setDataFile] = useState([]);
  const [dataJob, setDataJob] = useState([]);
  const [dataVerification, setDataVerification] = useState([]);
  const [modalActive, setModal] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalData, setModalData] = useState([]);


  useEffect(() => {
    getJobData();
    getFileData();
    // startPoolingData();
  }, []);

  const getFileData = () => {
    const param = jobID;

    Services.getJobFileByID(param)
    .then(res => {
      console.log('xxx file', res)
      setDataFile(res);
    })
    .catch(err => console.log(err));
  };

  const startPoolingData = () => {
    setInterval(() => {
      getJobData();
      getFileData();
    }, 3000);
  };

  const getJobData = () => {
    const param = jobID;

    Services.getJobListByID(param)
    .then(res => {
      console.log('xxx joblist', res.data)
      setDataJob(res.data);
      setDataVerification(res.verificationData);
    })
    .catch(err => console.log(err));
  };

  const toggleModal = () => setModal(!modalActive);
  const toggleModalHistory = (data) => {
    setModalHistory(!modalHistory);
    setModalData(data);
  }
  const setImage = (image) => setModalImage(image);

  return(
    <Panel>
      <ReactNotification/>
      <PanelHeader noButton>Detail Report </PanelHeader>
      <PanelBody>
        { dataJob.map(item => {
          return RenderTable(item)
        })}
        {RenderChecked(dataFile, toggleModal, setImage)}
        {RenderEvidence(dataFile, toggleModal, setImage)}
        {RenderHistoryVerification(dataVerification, toggleModalHistory)}
      </PanelBody>
      {RenderModal(modalActive, modalImage, toggleModal)}
      {RenderModalHistory(modalHistory, modalData, toggleModalHistory)}
    </Panel>
  )
}

const RenderHistoryVerification = (historyData, toggleModal) => {
  let no = 1;
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
       <h2>History Verifikasi</h2>
      <div className="table-responsive">
        <table className="table joblist">
          <thead>
            <tr style={{ border: "1px solid black"}}>
              <td rowspan={1} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>No</td>
              <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>Status</td>
              <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>Tanggal</td>
              <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>Diverifikasi oleh</td>
              <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>Detail</td>
            </tr>
          </thead>
          <tbody>
            {historyData.map(item => {
              return (
                <tr style={{ border: "1px solid black"}}>
                  <td style={{ textAlign: "center", border: "1px solid black"}}>{no++}</td>
                  <td style={{ textAlign: "center", border: "1px solid black"}}>{item.status}</td>
                  <td style={{ textAlign: "center", border: "1px solid black"}}>{moment(item.createDate).format('DD-MM-YYYY')}</td>
                  <td style={{ textAlign: "center", border: "1px solid black"}}>{item.userVerificator}</td>
                  <td style={{ textAlign: "center", border: "1px solid black"}}>
                    <button
                      onClick={() => toggleModal(item)}
                      className="btn btn-sm btn-success width-70 m-r-2"
                    >
                      Detail
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
  </div>
  )
}

const RenderChecked = (dataFile, toggleModal, setImage) => {
  const signatureData = dataFile.filter(item => item.fileType === "2");
  
  return(
    <div className="d-flex flex-column">
      <div style={{padding: 20}}>
        {RenderCheckedData(signatureData, toggleModal, setImage)}
      </div>
    </div>
  )
};

const RenderCheckedData = (signatureData, toggleModal, setImage) => {
  return (
    <div id="gallery" className="gallery">
      <h2>Diperiksa oleh</h2>
      {signatureData.map(item => {
        if(!item.asVerificator) {
          return (
            <div className={'image pull-left'}>
              <div>
                <img 
                  src={`data:image/png;base64, ${item.file}`}
                  style={{ maxWidth: "800", maxHeight: '90%', objectFit: 'cover'}}
                  alt=''
                  onClick={() => {
                    setImage(item.file);
                    toggleModal();
                  }}
                />
                <p className="image-caption">
                </p>
              </div>
              <div className="image-info">
                <h5 className="title"><small>by</small> {item.user}</h5>
                {/* <div className="pull-right">
                  <small>by</small> {item.user}
                </div>
                <div className="desc">
                  Nunc velit urna, aliquam at interdum sit amet, lacinia sit amet ligula. Quisque et erat eros. Aenean auctor metus in tortor placerat, non luctus justo blandit.
                </div> */}
              </div>
            </div>
            
          )
        }
      })}
    </div>
  )
}

const RenderEvidence = (dataFile, toggleModal, setImage) => {
  const evidenceData = dataFile.filter(item => item.fileType === "1");
  const signatureData = dataFile.filter(item => item.fileType === "2");
  
  return(
    <div className="d-flex flex-column">
      <div style={{padding: 20}}>
        {RenderEvidenceData(evidenceData, toggleModal, setImage)}
      </div>
      <div style={{padding: 20}}>
        {RenderSignatureData(signatureData)}
      </div>
    </div>
  )
}

const RenderEvidenceData = (evidenceData, toggleModal, setImage) => {
  return (
    <div id="gallery" className="gallery">
      <h2>Bukti Foto</h2>
      {evidenceData.map(item => {
        if(!item.asVerificator) {
          return (
            <div className={'image pull-left'}>
              <div>
                <img 
                  src={`data:image/png;base64, ${item.file}`}
                  style={{ maxWidth: "800", maxHeight: '90%', objectFit: 'cover'}}
                  alt=''
                  onClick={() => {
                    setImage(item.file);
                    toggleModal();
                  }}
                />
                <p className="image-caption">
                </p>
              </div>
              <div className="image-info">
                <h5 className="title"><small>by</small> {item.user}</h5>
                {/* <div className="pull-right">
                  <small>by</small> {item.user}
                </div>
                <div className="desc">
                  Nunc velit urna, aliquam at interdum sit amet, lacinia sit amet ligula. Quisque et erat eros. Aenean auctor metus in tortor placerat, non luctus justo blandit.
                </div> */}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

const RenderSignatureData = (signatureData) => {
  return (
    <div id="gallery" className="gallery">
      <h2>Verifikasi data</h2>
      {signatureData.map(item => {
        if (item.asVerificator) {
          return (
            <div className={'image pull-left'}>
              <div>
                <img 
                  src={`data:image/png;base64, ${item.file}`}
                  style={{ maxWidth: "800", maxHeight: '90%', objectFit: 'cover'}}
                  alt=''
                />
                <p className="image-caption">
                </p>
              </div>
              <div className="d-flex flex-column image-info">
                <h5 className="title" style={{fontWeight: 'bold', alignSelf: 'center'}}>{item.user}</h5>
                <h5 className="title" style={{fontWeight: '400', alignSelf: 'center'}}>{item.position}</h5>
                {/* <div className="pull-right">
                  <small>by</small> {item.user}
                </div>
                <div className="desc">
                  Nunc velit urna, aliquam at interdum sit amet, lacinia sit amet ligula. Quisque et erat eros. Aenean auctor metus in tortor placerat, non luctus justo blandit.
                </div> */}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

const RenderModal = (modalActive, modalData, toggleModal) => {
  return (
    <Modal isOpen={modalActive} toggle={() => toggleModal()} size="lg">
      <ModalHeader toggle={() => toggleModal()}></ModalHeader>
      <ModalBody>
        <div className="d-flex justify-content-center">
          <img src={`data:image/png;base64, ${modalData}`} style={{ maxWidth: 640, maxHeight: 480, objectFit: 'cover'}} alt=''/>
        </div>
      </ModalBody>
    </Modal>
  )
}

const RenderModalHistory = (modalActive, modalData, toggleModal) => {
  console.log('xxx modal data', modalData);
  return (
    <Modal isOpen={modalActive} toggle={() => toggleModal([])} size="lg">
      <ModalHeader toggle={() => toggleModal([])}>
        <h2>Detail Verifikasi</h2>
      </ModalHeader>
      <ModalBody className='d-flex flex-column'>
        <div className="d-flex justify-content-around">
          <h5>Tanggal : <b>{moment(modalData.createDate).format('DD-MM-YYYY')}</b></h5>
          <h5>Oleh : <b>{modalData.userVerificator}</b></h5>
        </div>
        <div className='form-group'>
          <h3>Catatan</h3>
          <input
            type="text"
            style={{width: '100%', height: 80}}
            value={modalData.notes}
            disabled
          />
        </div>
        <div className='form-group'>
          {modalData.file !== undefined && RenderStatusPhoto(modalData.file)}
        </div>
        <div className='form-group'>
          <h3>Status</h3>
          <input
            type="text"
            style={{width: '100%', height: 80}}
            value={modalData.status}
            disabled
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

const RenderStatusPhoto = (file) => (
  <div id="gallery" className="gallery">
    <h3>Foto</h3>
    {file.map(item => {
      return (
        <div className={'image pull-left'}>
          <div>
            <img 
              src={`${BASE_URL}/complaint-data-file/${item}`}
              style={{ maxWidth: "800", maxHeight: '90%', objectFit: 'cover'}}
              alt=''
            />
          </div>
        </div>
      )
    })}
  </div>
)

const RenderTable = (item) => {
  const headerData = NormalizeHeaderData(item.xItem);
  console.log('xxx item', item);
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
        <div className="table-responsive">
          <table className="table joblist">
            <thead>
              <tr style={{ border: "1px solid black"}}>
                <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>No</td>
                <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}>{item.name}</td>
                {RenderHeader(item.xItem, headerData)}
              </tr>
              {RenderSubHeader(headerData)}
            </thead>
            <tbody>
              {RenderBody(item.xItem, item.yItem)}
            </tbody>
          </table>
        </div>
    </div>
  )
}

const RenderHeader = (subModule, headerData) => {
  let colSpan = headerData[1].length !== 0 ? headerData[1].length : 0;

  return subModule.map(item => {
    return (
      <th 
        colspan={colSpan === 0 ? item.sub.length : colSpan}
        style={{ textAlign: "center", verticalAlign: "middle", border: "1px solid black"}}
        rowspan={item.sub.length === 0 && 3}
      >{item.name}</th>
    )
  })
}

const NormalizeHeaderData = (subModule) => {
  const dataArr = [];
  let arr1 = [];
  let arr2 = [];

  subModule.forEach(item => {
    if(item.sub.length > 0){
      item.sub.forEach(item2 => {
        const data1 = {
          name: item2.name,
          colSpan: item2.sub.length
        }
        arr1.push(data1);
        if(item2.sub.length > 0){
          item2.sub.forEach(item3 => {
            const data2 = {
              name: item3.name,
              colSpan: item3.sub.length
            }
            arr2.push(data2);
          })
        }
      })
    }
  });

  dataArr.push(arr1);
  dataArr.push(arr2);

  return dataArr;
}

const RenderSubHeader = (subModule) => {
  return subModule.map(xItem => {
    return (
      <tr>
        {xItem.map(item => {
          return <th colSpan={item.colSpan} style={{ textAlign: "center", border: "1px solid black"}}>{item.name}</th>
        })}
      </tr>
    )
  })
}

const RenderBody = (xItem, yItem) => {
  return yItem.items.map((item, idx) => {
    return (
      <tr style={{ border: "1px solid black"}}>
        <td style={{ textAlign: "center", border: "1px black"}}>{idx+1}</td>
        <td style={{ border: "1px solid black"}}>{item.name}</td>
        {xItem.map(item2 => {
          if(item2.sub.length > 0) {
            return item2.sub.map(item3 => {
              if(item3.sub.length > 0) {
                return item3.sub.map(item4 => {
                  let value = "";
                  let colorValue = "";
                  let isCheck = false;
                  if(item4.value[idx] === true || item4.value[idx] === false ) {
                    value = item4.value[idx] ? RenderCheck() : "";
                    isCheck = true;
                  } else {
                    value = item4.value[idx];
                    colorValue = parseInt(item4.value[idx]) >= item4.thresholdMax ? "red" : "black";
                  }
                  return <td style={{ border: "1px solid black", wordBreak: "break-word", textAlign: isCheck && 'center', color: colorValue}} colSpan="1">{value}</td>
                })
              } else {
                let value = "";
                let isCheck = false;
                let colorValue = "";
                if(item3.value[idx] === true || item3.value[idx] === false ) {
                  value = item3.value[idx] ? RenderCheck() : "";
                  isCheck = true;
                } else {
                  value = item3.value[idx];
                  colorValue = parseInt(item3.value[idx]) > item3.thresholdMax ? "red" : "black";
                }
                return <td style={{ border: "1px solid black", wordBreak: "break-word", textAlign: isCheck && 'center', color: colorValue}} colSpan="1">{value}</td>
              }
            })
          } else {
            let colorValue = item2.value[idx] >= item2.thresholdMax ? "red" : "black";
            return <td style={{ border: "1px solid black", wordBreak: "break-word", color: colorValue}} colSpan="1">{item2.value[idx]}</td>
          }
        })}
      </tr>
    )
  })
}

const RenderCheck = () => <i class="fas fa-lg fa-fw m-r-10 fa-check"></i>;

export default FormPreview;